<script>
    export default {
        
    }
</script>

<template>
    <div class="news-item is-flex">
        <div class="news-content is-flex-grow-1 is-flex is-flex-direction-column">
            <div class="news-image mb-3">
                <picture class="image has-curve-left-right"><img width="432" height="288" alt="" /></picture>
            </div>
            <div class="block"><div class="progress is-large" value="0" max="100"></div></div>
            <div v-for="index in 3" :key="index" class="block"><div class="progress" value="0" max="100"></div></div>
        </div>
    </div>
</template>
